import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import {PulseLoader} from '../';

const InfiniteScroller = (props) => {
  const {children, loadMore, hasMore} = props;

  return (
    <InfiniteScroll
      loadMore={loadMore}
      hasMore={hasMore}
      loader={<PulseLoader key={0}/>}
      useWindow={false}
      initialLoad={false}
      className="infinite-scroll"
    >
      {children}
    </InfiniteScroll>
  );
};

InfiniteScroller.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
  loadMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
};

InfiniteScroller.defaultProps = {
  hasMore: true,
};

export default InfiniteScroller;
